
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { VehicleViewAttachment } from '@/models/inventory/vehicle.inventory';
import { Base } from '@/components/common/base';
import {vehicleInventoryService} from '@/shared';

@Component({
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
    },
})

export default class CheckVehicleLocationViewAttachment extends Base {
    public loading: boolean = false;
    public attachments: VehicleViewAttachment[] = [];
    public headers: VHeaders[] = [
        {
            text: this.$parent.$t('checkVehicleLocation.headers.name') as string,
            align: 'left',
            value: 'name',
            sortable: true,
        },
        {
            text: this.$parent.$t('checkVehicleLocation.headers.actions') as string,
            align: 'center',
            isNotDataProp: true,
            sortable: false,
        },
    ];
    public actions: any[] = [
        {
            type: 'button',
            icon: 'fas fa-download',
            title: this.$parent.$t('checkVehicleLocation.headers.gridAction.downloadAttachment') as string,
            action: (model: VehicleViewAttachment) => {
                if (model && model.uri) {
                    return window.open(model.uri);
                }
            },
        }];
    public pagination = new PaginationModel('name', true);
    public externalId: string;

    public mounted() {
        this.externalId = this.$route.params.externalId;
        this.getAttachment();
    }
    public async getAttachment(): Promise<void> {
        try {
            this.loading = true;
            const response = await vehicleInventoryService.getVinAttachments(this.externalId);
            this.attachments = response;
            this.pagination.totalItems = response.length;
        } finally {
            this.loading = false;
        }
    }

    public updatePaging(paging: any): void {
        this.pagination = paging;
    }
}
